import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage } from '../../../core';
import { IControlProps, MapProps } from '..';
import Translate from '../../../core/translate';
import { ISociedad } from '../../../services/api/entity/model';
import { IPaginatedResponse } from '../../../services/model';
import GridComponent, { Index as Grid, getDataFromArray, IPagination, SelectModes } from '../../grid';
import { Button, Chips, Dialog, SelectButton } from '../../prime';
import styles from './selectsociedades.module.scss';
import API from '../../../services/api';
import Alert from '../../alerts';

const DiccionaryKey = 'components/forms/cliente/selectsociedades';

interface IProps extends IControlProps<number[]> { 
  storage?: IDataStorage;
}

interface IState extends IControlProps<number[]> {
  storage?: IDataStorage;

  /** Indica el mensaje de error si es que existe */
  validError?: string;

  modal?: { 
    filterSelected: string[];
  }

  sociedades?: ISociedad[];
}

class Index extends React.Component<IProps, IState> {
  state: IState = {};
  grid: Grid | null = null;

  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    this.loadentities();
    if (this.props?.form && this.props?.name) this.props.form.add(this, this.props.name);
  }
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p?.storage;
    if (p?.value !== s?.value || p?.value?.length !== s?.value?.length) res.value = p?.value;
    return MapProps(res, p, s);
  }
  loadentities = () => {
    const t = Translate.get(DiccionaryKey, this.state.storage?.languaje);
    API.entity().sociedad().find({ activo: true })
      .then(e => {
        Alert.reponse(e);
        this.setState({ sociedades: e.data })
      }).catch(ex => Alert.error(t("@Id#ErrorInesperado"), `${ex}`));
  }
  
  getGridData = (pag?: IPagination | undefined, sort?: string | undefined, filters?: any) : Promise<IPaginatedResponse<ISociedad>> =>
    getDataFromArray(pag, sort, filters, this.state.sociedades ?? [], rows => {
      
      const isSelected = (v:ISociedad) => !!this.state.value?.includes(v.id!);

      // custom filter
      const verSelected = !!this.state.modal?.filterSelected.find(p => p === "si");
      const verUnSelected = !!this.state.modal?.filterSelected.find(p => p === "no");
      if (!verSelected) rows = rows.filter((p:any) => !isSelected(p)).slice(0);
      if (!verUnSelected) rows = rows.filter((p:any) => isSelected(p)).slice(0);


      if (!!filters && !!filters["nombre"]) rows = rows.filter(row => new RegExp(filters["nombre"].value, 'i').test(row.nombre) );
      return rows;
    });

  render() {    
    const { validError, value, modal, sociedades } = this.state;
    const t = Translate.get(DiccionaryKey, this.state.storage?.languaje);
    const chips = sociedades?.filter(p => value?.includes(p.id!)).map(p => p.nombre);
    const isSelected = (v:ISociedad) => !!this.state.value?.includes(v.id!);
    let order = 0;

    return <>
      <div className={`form-group ${this.state.className ?? ''}`} style={this.state.style}>
        {this.state.title && <label className={(validError && styles.errortitle) ?? ''}>{this.state.title}</label>}
        <div className={`${styles.addons} p-inputgroup`}>
          {this.state.required && 
            <span className={`p-inputgroup-addon ${(validError && styles.erroraddon) ?? ''}`}>
              <i className="pi pi-exclamation-circle" />
            </span>
          }
          <Chips value={chips} className={styles.input} />
          <Button 
            icon={this.state.disabled ? 'pi pi-eye' : 'pi pi-search'} 
            className="p-button-primary" 
            onClick={() => this.setState({ modal: { filterSelected: ["si","no"] } })} 
            tooltip={this.state.disabled ? t("Open.Ver.Tooltip") : t("Open.Editar.Tooltip")}
            tooltipOptions={{position:'top'}} 
          />
        </div>
        {validError && <span className={styles.errordesc}>{validError}</span>}
      </div>

      <Dialog 
        modal
        header={<><span className="fas fa-university" /> {t(`Modal.Titulo`)}</>}
        style={{width: '70%'}}
        footer={
          <div style={{ fontSize: '.8em' }}>
            <span style={{float:'left', fontSize:'1.7em'}} />
            <Button label={t('Modal.Cerrar')} className="p-button-secondary" onClick={() => this.setState({ modal: undefined })} tooltip={t('Modal.Cerrar.Tooltip')} tooltipOptions={{position:'top'}} />
          </div>
        }
        visible={!!modal} 
        dismissableMask
        onHide={() => this.setState({ modal: undefined })}
      >
        <GridComponent
          selectMode={SelectModes.single}
          name="component//cliente/selectsociedades"
          syncGrid={e => this.grid = e}
          data={this.getGridData}
          autoLoad
          columns={[
            { order: ++order, field: 'codigo', header: t('Modal.Grid.codigo'), sortable: true, filter: false },
            { order: ++order, field: 'nombre', header: t('Modal.Grid.nombre'), sortable: true, filter: true, filterPlaceholder: t("Modal.Grid.nombre.Placeholder") },
            { order: ++order, field: 'selected', header: t("Modal.Col.selected"), sortable: false, filter: true, style:{ textAlign: 'center', width: 200 }, hideForExport: true,
              body:r => {
                const sel = isSelected(r);
                return <Button
                  className={`${sel ? 'p-button-primary' : 'p-button-secondary'}`}
                  style={{ padding: '0 10px 0 10px', width: 'auto' }}
                  label={sel ? t("Modal.Col.selected.si") : t("Modal.Col.selected.no")}
                  icon={sel ? 'fas fa-check' : 'fas fa-ban'}
                  disabled={this.state.disabled}
                  onClick={() => {
                    if (modal && !sel) this.add(r);
                    if (modal && sel) this.remove(r)
                  }}
                />
              }, 
              filterElement:
                <SelectButton
                  optionLabel="name" 
                  optionValue="value" 
                  multiple
                  value={this.state.modal?.filterSelected}
                  className="p-column-filter"
                  style={{ textAlign:'center'}}
                  tooltip={t("Modal.Col.selected.Tooltip")}
                  tooltipOptions={{position:'bottom'}}
                  options={[
                    { name: 'Seleccionado', value: "si", icon: 'fas fa-check' },
                    { name: 'No Seleccionado', value: "no", icon: 'fas fa-ban'}
                  ]}
                  itemTemplate={o => <i className={`${o.icon}`} style={{ fontSize: '1em', width: '1em'}} />}
                  onChange={(e) => { if (modal) {
                    modal.filterSelected = e.value;
                    this.setState({ modal }, () => this.grid?.refresh());
                  }}}
                />
            }
          ]}
          columnCommandsWidth="65px"
        />
      </Dialog>
    </>
  }

  remove = (row:ISociedad) => this.state.value && this.change(this.state.value?.filter(p => p !== row.id) ?? []);
  add = (row:ISociedad) => this.state.value && this.change([ ...this.state.value, ...[row.id!]]);

  change = (newvalue: number[]) => {
    this.setState({ value: newvalue }, () => {
      const { onChange } = this.props;
      if (onChange) onChange(newvalue, undefined);
      this.grid?.refresh();
    });
  }

}

export default connect((s:any) => ({ storage:s.main }))(Index);
